const { recommendRandomSort, formatImage, formatUrl } = require('@ifeng-fe/public_method');

module.exports = {
    jsonParse: data => {
        return JSON.parse(data);
    },

    handleTopNewsFirstListPicData: data => {
        return data.slice(0, 2).map(item => ({
            thumbnail: formatImage(item.thumbnail, 160, 90),
            url: formatUrl(item.url),
            title: item.title,
            id: item.id,
            commentUrl: item.url,
        }));
    },
    handleTopNewsEndListPicData: data => {
        return data.slice(0, 1).map(item => ({
            thumbnail: formatImage(item.thumbnail, 160, 90),
            url: formatUrl(item.url),
            title: item.title,
            id: item.id,
            commentUrl: item.url,
        }));
    },
    handleSpecialSlider: data => {
        return data.slice(0, 4).map(item => ({
            thumbnail: formatImage(item.thumbnail, 300, 600),
            url: formatUrl(item.url),
            title: item.title,
            summary: item.summary,
            id: item.id,
            commentUrl: item.url,
        }));
    },
    handleVideoList: data => {
        return recommendRandomSort(data, 6).map(item => ({
            thumbnail: formatImage(item.thumbnail, 120, 92),
            url: formatUrl(item.url),
            title: item.title,
            id: item.id,
            commentUrl: item.url,
        }));
    },

    handleSpecialListData: data => {
        return data.slice(0, 4).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
            id: item.id,
            commentUrl: item.url,
        }));
    },
    handleShowListData: data => {
        return data.slice(0, 1).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
            thumbnail: formatImage(item.thumbnail, 299, 210),
            id: item.id,
            commentUrl: item.url,
        }));
    },
    handleSliderListData: data => {
        return data.slice(0, 1).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
            thumbnail: formatImage(item.thumbnail, 650, 360),
            id: item.id,
            commentUrl: item.url,
        }));
    },
    handleS01LeftSliderData: data => {
        const result = data.slice(0, 6).map(item => ({
            id: item.id,
            url: formatUrl(item.url),
            title: item.title,
            thumbnail: formatImage(item.thumbnail, 650, 390),
            summary: item.summary,
        }));

        return result;
    },
    handles01column: data => {
        let result = [];

        result = data.slice(0, 4).map((item, index) => {
            const __image = item.thumbnail ? formatImage(item.thumbnail, 310, 475) : '';

            return {
                title: item.title,
                summary: item.summary,
                pic: __image,
                url: formatUrl(item.url),
            };
        });

        return result;
    },
    handles01columnVideo: data => {
        return data.map(item => ({
            title: item.title,
            url: item.url,
            guid: item.guid,
            videoPlayUrl: item.videoPlayUrl,
            posterUrl: item.posterUrl,
        }));
    },
    handles01columnBigPic: data => {
        let result = [];

        result = data.slice(0, 3).map((item, index) => {
            const __image = item.thumbnail ? formatImage(item.thumbnail, 300, 600) : '';

            return {
                title: item.title,
                summary: item.summary,
                pic: __image,
                url: formatUrl(item.url),
            };
        });

        return result;
    },

    handles01columnTxtPic: data => {
        let result = [];

        result = data.slice(0, 3).map((item, index) => {
            const __image = item.thumbnail ? formatImage(item.thumbnail, 140, 85) : '';

            const oriSummary = item.summary || '';

            return {
                title: item.title,

                summary: oriSummary,
                pic: __image,
                url: formatUrl(item.url),
            };
        });

        return result;
    },

    handles02SliderData: data => {
        let result = [];
        const length = data.length;

        const column3 = length > 3;

        result = data.slice(0, 5).map((item, index) => {
            let w = 200;
            let h = 132;

            if (column3) {
                if (index === 2) {
                    w = 502;
                    h = 323;
                }
            } else if (index === 0) {
                w = 742;
                h = 324;
            }

            // const __image = item.thumbnail ? formatImage(item.thumbnail, 200, 132) : ''; // 1
            // const __image = item.thumbnail ? formatImage(item.thumbnail, 742, 324) : ''; // 3
            // const __image = item.thumbnail ? formatImage(item.thumbnail, 502, 323) : ''; // 2

            const __image = item.thumbnail ? formatImage(item.thumbnail, w, h) : '';

            return {
                title: item.title,
                subTitle: item.subTitle,
                categoryName: item.categoryName,
                topicTitle: item.topicTitle,
                url: formatUrl(item.url),
                thumbnail: __image,
                summary: item.summary,
            };
        });

        return result;
    },

    handleS03LeftBrand: data => {
        let result = [];

        result = data.slice(0, 9).map(item => {
            let w = 210;
            let h = 375;

            const __image = item.thumbnail ? formatImage(item.thumbnail, w, h) : '';

            return {
                id: item.id,
                title: item.title,
                thumbnail: __image,
                url: formatUrl(item.url),
                summary: item.summary,
            };
        });

        return result;
    },

    handleS03RightFashionWeek: data => {
        let result = [];

        result = data.slice(0, 4).map(item => {
            let w = 300;
            let h = 225;

            const __image = item.thumbnail ? formatImage(item.thumbnail, w, h) : '';

            return {
                id: item.id,
                title: item.title,
                thumbnail: __image,
                url: formatUrl(item.url),
                summary: item.summary,
            };
        });

        return result;
    },

    handleS03RightSkin: data => {
        let result = [];

        result = data.slice(0, 3).map(item => {
            let w = 300;
            let h = 225;

            const __image = item.thumbnail ? formatImage(item.thumbnail, w, h) : '';

            return {
                id: item.id,
                title: item.title,
                thumbnail: __image,
                url: formatUrl(item.url),
                summary: item.summary,
            };
        });

        return result;
    },

    handleS03RightTv: data => {
        let result = [];

        result = data.slice(0, 4).map(item => {
            let w = 300;
            let h = 200;

            const __image = item.thumbnail ? formatImage(item.thumbnail, w, h) : '';

            return {
                id: item.id,
                title: item.title,
                thumbnail: __image,
                url: formatUrl(item.url),
                summary: item.summary,
            };
        });

        return result;
    },

    handles04Pics: data => {
        let result = [];

        result = data.slice(0, 8).map((item, i) => {
            const size1 = [0, 1, 3, 4, 6, 7];
            const size2 = [2];
            const size3 = [5];

            //  0 1 3 4 6 7
            let w = 199;
            let h = 262;

            // // 2
            // let w = 199;
            // let h = 525;

            // // 5
            // let w = 399;
            // let h = 262;

            if (size2.includes(i)) {
                w = 199;
                h = 525;
            } else if (size3.includes(i)) {
                w = 399;
                h = 262;
            }

            const __image = item.thumbnail ? formatImage(item.thumbnail, w, h) : '';

            return {
                ...item,
                thumbnail: __image,
                url: formatUrl(item.url),
            };
        });

        return result;
    },
    // 美食频道
    handleFoodSlide: data => {
        return data.slice(0, 6).map(item => ({
            thumbnail: formatImage(item.thumbnail, 650, 366),
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleFoodMainSlide: data => {
        return data.slice(0, 3).map(item => ({
            thumbnail: formatImage(item.thumbnail, 650, 366),
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleFoodMainList: data => {
        return data.slice(0, 5).map(item => ({
            thumbnail: formatImage(item.thumbnail, 650, 366),
            id: item.id,
            url: formatUrl(item.url),
            summary: item.summary,
            title: item.title,
            source: item.source,
            newsTime: item.newsTime,
            commentUrl: item.commentUrl
        }));
    },
    handleFoodRightNews: data => {
        return data.slice(0, 3).map(item => ({
            thumbnail: formatImage(item.thumbnail, 300, 225),
            url: formatUrl(item.url),
            title: item.title,
            id: item.id
        }));
    },
    handleFoodLeftNews: data => {
        return data.slice(0, 2).map(item => ({
            thumbnail: formatImage(item.thumbnail, 310, 232),
            url: formatUrl(item.url),
            title: item.title,
            id: item.id
        }));
    },
    handleFoodCenterNews: data => {
        return data.slice(0, 1).map(item => ({
            thumbnail: formatImage(item.thumbnail, 310, 492),
            url: formatUrl(item.url),
            title: item.title,
            id: item.id
        }));
    },
};
